module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-016ed0857df8c0ca7f74eb192f5a28c4.png";